module.exports = __webpack_public_path__ + "static/media/sand_vert_slid.a9a8f632.png";